export default __webpack_public_path__ + "static/media/ptnlogo.c43d041f.png";